import React, { Component } from "react";

import { Input, Form } from "@rocketseat/unform";
import Base from "../../components/Base";

import "./styles.css";
import { Button, Modal } from "antd";

import api from "../../services/api";
import handleError from "../../services/apiErrorHandler";

export default class RelatorioFiltro extends Component {
  state = {
    hdi: null,
    sancor: null,
    consultado: false,
    loading: false
  };

  handleSubmit = async data => {
    let data_start = data.data_start;
    let data_end = data.data_end;

    if (data_start == null || data_start.length == 0) {
      Modal.error({
        title: "Erro",
        content: "Informe a primeira data!"
      });
      return;
    }

    if (data_end == null || data_end.length == 0) {
      Modal.error({
        title: "Erro",
        content: "Informe a segunda data!"
      });
      return;
    }

    this.setState({
      loading: true
    });

    await api
      .get("/filtro/relatorio/", {
        params: data
      })
      .then(response => {
        this.setState({
          hdi: response.data.hdi,
          sancor: response.data.sancor,
          consultado: true
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <Base title="Relatório de filtros">
        <div className="relatorio_container">
          <div className="relatorio_title">Selecione o período:</div>
          <Form onSubmit={this.handleSubmit}>
            <div className="relatorio_block">
              <div className="d-flex">
                <Input name="data_start" type="date" className="ant-input" />
                &nbsp;até&nbsp;
                <Input name="data_end" type="date" className="ant-input" />
                &nbsp;&nbsp;
                <Button
                  htmlType="submit"
                  type="primary"
                  loading={this.state.loading}
                >
                  Consultar
                </Button>
              </div>
              <br />
              {this.state.consultado ? (
                <div className="relatorio_infos d-flex">
                  <div>
                    HDI: <b>{this.state.hdi}</b>
                  </div>
                  <div>
                    SANCOR: <b>{this.state.sancor}</b>
                  </div>
                </div>
              ) : null}
            </div>
          </Form>
        </div>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/RelatorioFiltro/index.js